module.exports = __webpack_public_path__ + "img/kunai.3108ca84.svg";